module.exports = __webpack_public_path__ + "img/bottom-characters.0545ab44.png";